import {
  CREATE_NEW_PARTNER,
  GET_PARTNER_DETAILS,
  GET_PARTNER_CAMPAIGNS,
  GET_PARTNER_STATEMENTS,
  GET_PARTNER_TRANSACTIONS,
  UPDATE_PARTNER_DETAILS,
} from "../../gql/partner";
import { ApolloClientPartnerService } from "../../services/ApolloClientPartnerService";
import {
  setPartnerDetails,
  setPartnerCampaigns,
  setPartnerStatements,
  setPartnerTransactions,
} from "./reducer";

export const createNewPartner = async (input) => {
  try {
    const { data } = await ApolloClientPartnerService.mutate({
      mutation: CREATE_NEW_PARTNER,
      operationName: "CREATE_NEW_PARTNER",
      variables: { input },
      fetchPolicy: "network-only",
    });
    const response = data?.createNewPartner || {};
    return response;
  } catch (err) {
    return err;
  }
};

export const getPartnerDetails = async (input, dispatch) => {
  try {
    const { data } = await ApolloClientPartnerService.mutate({
      mutation: GET_PARTNER_DETAILS,
      operationName: "GET_PARTNER_DETAILS",
      variables: { input },
      fetchPolicy: "network-only",
    });
    const response = data?.getPartnerDetails || {};
    dispatch(setPartnerDetails(response));
    return response;
  } catch (err) {
    return err;
  }
};

export const getPartnerCampaigns = async (input, dispatch) => {
  try {
    const { data } = await ApolloClientPartnerService.query({
      query: GET_PARTNER_CAMPAIGNS,
      operationName: "GET_PARTNER_CAMPAIGNS",
      variables: { input },
      fetchPolicy: "network-only",
    });
    const response = data?.getPartnerCampaigns || {};
    dispatch(setPartnerCampaigns(response));
    return response;
  } catch (err) {
    return err;
  }
};

export const getPartnerStatements = async (input, dispatch) => {
  try {
    const { data } = await ApolloClientPartnerService.query({
      query: GET_PARTNER_STATEMENTS,
      operationName: "GET_PARTNER_STATEMENTS",
      variables: { input },
      fetchPolicy: "network-only",
    });
    const response = data?.getPartnerStatements || {};
    dispatch(setPartnerStatements(response));
    return response;
  } catch (err) {
    return err;
  }
};

export const getPartnerTransactions = async (input, dispatch) => {
  try {
    const { data } = await ApolloClientPartnerService.query({
      query: GET_PARTNER_TRANSACTIONS,
      operationName: "GET_PARTNER_TRANSACTIONS",
      variables: { input },
      fetchPolicy: "network-only",
    });
    const response = data?.getPartnerTransactions || {};
    dispatch(setPartnerTransactions(response));
    return response;
  } catch (err) {
    return err;
  }
};

export const updatePartnerDetails = async (input, dispatch) => {
  try {
    const { data } = await ApolloClientPartnerService.mutate({
      mutation: UPDATE_PARTNER_DETAILS,
      operationName: "UPDATE_PARTNER_DETAILS",
      variables: { input },
      fetchPolicy: "network-only",
    });
    const response = data?.updatePartnerDetails || {};
    dispatch(setPartnerDetails(response));
    return response;
  } catch (err) {
    return err;
  }
};
